import { RegisterUserStepResponse } from '../../../../../../types/api/endpoints/auth/register.types';
import { AUTH_ENDPOINTS } from '../../../../../../utils/api/endpoints/authEndpoints';
import { RegisterUserStepFormSchema } from './RegisterUserStepForm.types';

const PREFIX = '[registerUserQuery]';

export const REGISTER_USER_QUERY_KEY = 'REGISTER_USER';

export const registerUserQuery = async (data: RegisterUserStepFormSchema) => {
  console.log(PREFIX, `Requesting user account creation...`);
  const response = await AUTH_ENDPOINTS.user(data);

  const { ok, data: json } = response;

  console.log('ressss', response);

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user account creation.`);
  return json as RegisterUserStepResponse;
};
